module.exports = __webpack_public_path__ + "img/base_control.ab975c49.svg";